<template>
<validation-provider v-if="layout === 'v'" tag="div" class="vx-row mb-6" :rules="validateRules" v-slot="v">
      <div class="vx-col w-full sm:text-right" :class="[_labelSplit, alignClass]" v-if="!hideLabel">
        <span class="w-full"><span class="text-danger" v-if="required || ~validateRules.indexOf('required')">*</span>{{label}} <span v-if="label">：</span></span>
      </div>
      <div class="vx-col w-full" :class="[_wrapSplit, {'vs-input-danger': v.errors && v.errors.length}]">
          <slot v-bind="v" />
          <label class="block text-sm vs-input--label text-grey" v-if="help" v-html="help"></label>
          <label class="block text-sm vs-input--label text-danger" v-for="(m, k) in v.failedRules" :key="k" >{{msgs[k] || (label && ('必须填写' + label)) || m}}</label>
      </div>
</validation-provider>
<validation-provider tag="div" v-else :rules="validateRules" v-slot="v">
  <label class="vs-input--label" style="height:14px" v-if="!hideLabel">{{label}}</label>
  <br v-if="!hideLabel" />
  <div :class="{'vs-input-danger': v.errors && v.errors.length}">
    <slot v-bind="v" />
  </div>
  <label class="block text-sm vs-input--label text-grey" v-if="help" v-html="help"></label>
  <label class="block text-sm vs-input--label text-danger" v-for="(m, k) in v.failedRules" :key="k" >{{msgs[k] || (label && ('必须填写' + label)) || m}}</label>
</validation-provider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
export default {
  components: {
    ValidationProvider,
  },
  name: 'form-item',
  props: {
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    required: Boolean,
    labelSplit: {
      type: String,
      default: ''
    },
    labelAlign: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    wrapSplit: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: '',
    },
    msgs: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formComp() {
      return this.findForm(this.$parent)
    },
    layout() {
      let formComp = this.formComp
      if (!formComp) {
        return 'h'
      }
      return formComp.layout || 'h'
    },
    _labelSplit() {
      return this.labelSplit || (this.formComp && this.formComp.labelSplit) || 'sm:w-1/4'
    },
    alignClass() {
      const v = this.labelAlign || (this.formComp && this.formComp.labelAlign) || 'center'
      switch (v) {
        case 'center':
          return 'flex items-center'
        case 'top':
          return 'form-item-label-align-top'
        default:
          return ''
      }
    },
    _wrapSplit() {
      return this.wrapSplit || (this.formComp && this.formComp.wrapSplit) || 'sm:w-1/2'
    },
    validateRules() {
      const rules = this.rules.split('|')
      if (this.required && !~rules.indexOf('required')) {
        rules.push('required')
      }
      return rules.join('|')
    }
  },
  methods: {
    findForm(vm) {
      if (vm.$options._componentTag === 'vx-form') {
        return vm
      }
      if (vm.$parent) {
        return this.findForm(vm.$parent)
      }
    }
  }
}
</script>
<style lang="scss">
.form-item-label-align-top {
  margin-top: 10px;
}
.vs-input-danger .vs-input--input {
  border: 1px solid rgba(var(--vs-danger),1)!important;
}
</style>